import { EcommercePurchaseItem } from '@shared/v2/utils/dataLayer';

import { getNightsStay } from './getEcommerceDetailedItemEventData';
import getEcommerceItem from './getEcommerceItemEventData';

const getPropertyLocation = (
  destinationTitle: string,
  state: string,
  country: string,
): string => {
  return [destinationTitle, state, country]
    .filter((value) => !!value)
    .join(', ');
};

const getPaymentType = (payment: any) => {
  if (!!payment.points && !!payment.creditCard) {
    return 'pointsPlusPay';
  } else if (!!payment.points && !payment.creditCard) {
    return 'points';
  }
  return 'cash';
};

export const getEcommercePurchaseItem = ({
  bookingData,
}: {
  bookingData: any;
}): EcommercePurchaseItem => {
  const {
    property,
    flights,
    roomType,
    tiers,
    charges,
    stay,
    paymentBreakdown,
  } = bookingData;
  const price = Number(charges.total.amount);

  const item = getEcommerceItem({
    property,
    tiers,
    index: 1,
    price,
    originCode: flights.outbound[0].origin.code,
    itemVariant: roomType.name,
    destinationTitle: flights.outbound[0].destination.name,
    forceOverridePrice: true,
  });

  const numberOfPassengers =
    (stay.adults ?? 0) + (stay.children ?? 0) + (stay.infants ?? 0);

  const nights = getNightsStay(stay.checkIn, stay.checkOut)!;

  const pointsValue = paymentBreakdown.points?.points
    ? paymentBreakdown.points?.points / nights
    : 0;

  return {
    ...item,
    price,
    number_of_nights: nights,
    travellers_adult: stay.adults,
    travellers_children: stay.children,
    travellers_infant: stay.infants,
    item_variant: roomType.name,
    rating: property.rating,
    image_count: 1,
    start_date: stay.checkIn,
    end_date: stay.checkOut,
    origin: flights.outbound[0].origin.name,
    destination: flights.outbound[0].destination.name,
    number_of_rooms: 1,
    number_of_passengers: numberOfPassengers || undefined,
    includes: property.facilities.join(', '),
    item_offer: property.facilities.join(', '),
    payment_type: getPaymentType(paymentBreakdown),
    location: getPropertyLocation(
      flights.outbound[0].destination.name,
      property.stateCode,
      property.countryName,
    ),
    international_or_domestic:
      property.countryCode !== 'AU' ? 'International' : 'Domestic',
    flight_type: 'return',
    flight_number: flights.outbound[0].flightNumber,
    travel_class: flights.outbound[0].flightClass,
    cash_used: Number(paymentBreakdown.creditCard?.total.amount) || 0,
    points_used: Number(paymentBreakdown.points?.points) || 0,
    points_value: pointsValue,
    rebook: undefined,
    domestic_type: undefined,
    original_price: price,
    recommend: undefined,
  };
};

export default getEcommercePurchaseItem;
